module.exports = __webpack_public_path__ + "static/img/hexibanner3.b10f9b5e.jpg";